(function () {
  if (window.__bcInit) return;
  window.__bcInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('bc-visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }) : null;

  function initReveals(root) {
    (root || document).querySelectorAll('.bc-reveal, .bc-hero').forEach(function (el) {
      if (el.dataset.bcObs) return; el.dataset.bcObs = '1';
      if (io && !reduce) io.observe(el); else el.classList.add('bc-visible');
    });
  }

  /* Héroe verano / invierno */
  function initHero(root) {
    (root || document).querySelectorAll('.bc-hero').forEach(function (hero) {
      if (hero.dataset.bcInit) return; hero.dataset.bcInit = '1';
      var botones = hero.querySelectorAll('.bc-switch button');
      var auto = hero.dataset.auto === 'true' && !reduce;
      var seg = parseInt(hero.dataset.segundos || '5', 10) * 1000;
      var timer = null;
      function poner(modo) {
        hero.dataset.modo = modo;
        botones.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.modo === modo ? 'true' : 'false'); });
      }
      botones.forEach(function (b) {
        b.addEventListener('click', function () { poner(b.dataset.modo); if (timer) { clearInterval(timer); timer = null; } });
      });
      if (auto) {
        timer = setInterval(function () { poner(hero.dataset.modo === 'verano' ? 'invierno' : 'verano'); }, seg);
      }
    });
  }

  /* Hotspots */
  function initHotspots(root) {
    (root || document).querySelectorAll('.bc-hs').forEach(function (sec) {
      if (sec.dataset.bcInit) return; sec.dataset.bcInit = '1';
      var puntos = sec.querySelectorAll('.bc-hs__punto');
      var items = sec.querySelectorAll('.bc-hs__item');
      function activar(i) {
        puntos.forEach(function (p, j) { p.setAttribute('aria-expanded', i === j ? 'true' : 'false'); });
        items.forEach(function (it, j) { it.classList.toggle('bc-activo', i === j); });
      }
      puntos.forEach(function (p, i) { p.addEventListener('click', function () { activar(i); if (items[i] && window.innerWidth < 990) items[i].scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }); p.addEventListener('mouseenter', function () { activar(i); }); });
      items.forEach(function (it, i) { it.addEventListener('mouseenter', function () { activar(i); }); it.addEventListener('click', function () { activar(i); }); });
      activar(0);
    });
  }

  /* FAQ con apertura suave */
  function initFaq(root) {
    (root || document).querySelectorAll('.bc-faq__item').forEach(function (d) {
      if (d.dataset.bcInit) return; d.dataset.bcInit = '1';
      if (d.open) d.classList.add('bc-abierto');
      var s = d.querySelector('summary');
      s.addEventListener('click', function (ev) {
        ev.preventDefault();
        if (d.open) {
          d.classList.remove('bc-abierto');
          setTimeout(function () { d.open = false; }, reduce ? 0 : 450);
        } else {
          d.open = true;
          requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.add('bc-abierto'); }); });
        }
      });
    });
  }

  /* Botón magnético */
  function initMagnetico(root) {
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    (root || document).querySelectorAll('.bc-magnetico').forEach(function (b) {
      if (b.dataset.bcInit) return; b.dataset.bcInit = '1';
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) / r.width;
        var y = (e.clientY - r.top - r.height / 2) / r.height;
        b.style.transform = 'translate(' + (x * 10).toFixed(1) + 'px,' + (y * 8).toFixed(1) + 'px)';
      });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
  }

  /* Galería y compra de la página de producto */
  function initProducto(root) {
    (root || document).querySelectorAll('.bc-prod').forEach(function (sec) {
      if (sec.dataset.bcInit) return; sec.dataset.bcInit = '1';
      var principal = sec.querySelector('.bc-prod__principal img');
      sec.querySelectorAll('.bc-prod__mini').forEach(function (m) {
        m.addEventListener('click', function () {
          sec.querySelectorAll('.bc-prod__mini').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
          m.setAttribute('aria-current', 'true');
          if (principal) { principal.style.opacity = 0; setTimeout(function () { principal.src = m.dataset.src; principal.style.opacity = 1; }, 180); }
        });
      });
      var cant = sec.querySelector('.bc-prod__cant input');
      sec.querySelectorAll('.bc-prod__cant button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(cant.value || '1', 10) + parseInt(b.dataset.paso, 10);
          cant.value = Math.max(1, v);
        });
      });
      var json = sec.querySelector('[data-bc-variantes]');
      var selects = sec.querySelectorAll('.bc-prod__opcion select');
      if (!json || !selects.length) return;
      var variantes = JSON.parse(json.textContent);
      var inputId = sec.querySelector('input[name="id"]');
      var precio = sec.querySelector('[data-bc-precio]');
      var tachado = sec.querySelector('[data-bc-tachado]');
      var boton = sec.querySelector('[data-bc-boton]');
      selects.forEach(function (s) {
        s.addEventListener('change', function () {
          var vals = Array.prototype.map.call(selects, function (x) { return x.value; });
          var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === vals[i]; }); });
          if (!v) return;
          inputId.value = v.id;
          if (precio) precio.textContent = v.precio;
          if (tachado) { tachado.textContent = v.tachado || ''; }
          if (boton) { boton.disabled = !v.available; boton.querySelector('span').textContent = v.available ? boton.dataset.texto : boton.dataset.agotado; }
        });
      });
    });
  }

  function initTodo(e) {
    var root = e && e.target && e.target.querySelectorAll ? e.target : document;
    initReveals(root); initHero(root); initHotspots(root); initFaq(root); initMagnetico(root); initProducto(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo); else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
